import React, {useEffect, useState} from "react";
import {Grid} from "@material-ui/core";
import {Footer,} from "../../components";
import Seo from "../../components/Seo";
import {withRouter} from "react-router-dom";
import axios from "axios";
import './styles.scss'
import LocalAtmIcon from '@material-ui/icons/LocalAtm';
import PagesIcon from '@material-ui/icons/Pages';
import CardGiftcardIcon from '@material-ui/icons/CardGiftcard';
import AcUnitIcon from '@material-ui/icons/AcUnit';
import AssistantIcon from '@material-ui/icons/Assistant';
import {LogoIcon, LogoText} from '../../assets/images/images';
import {APP_DOMAIN_PREFIX} from "../../environment";
import i11 from './11.png';
import i8 from './8.png'
import i9 from './9.png'
import i10 from './10.png'
import i12 from './122.png'

const ICON_MAP = {
  LocalAtm: LocalAtmIcon,
  Pages: PagesIcon,
  CardGiftcard: CardGiftcardIcon,
  AcUnit: AcUnitIcon,
  Assistant: AssistantIcon,
};

const STAT_TILES = [
  {key: 'happyCustomers', img: i8},
  {key: 'stockInventory', img: i9},
  {key: 'ourVendors', img: i10},
  {key: 'ourServices', img: i12},
];

function AboutUsPage(props) {
  const [features, setFeatures] = useState([]);
  const [stats, setStats] = useState({});

  useEffect(() => {
    axios.get(`${APP_DOMAIN_PREFIX}/api/aboutus/features`).then((res) => {
      if (res) setFeatures(res.data);
    });
    axios.get(`${APP_DOMAIN_PREFIX}/api/homepage/stats`).then((res) => {
      if (res) setStats(res.data);
    });
  }, []);

  return (
    <>
      <Seo
        title="About Us"
        description="AgriLive is a verified digital agriculture marketplace closing the field-to-fair-price gap for smallholder farmers — seed to table."
        path="/aboutUs"
      />
      {/*<TopNavBar onClick={onSearchClick} />*/}

      <div className=" ">

        <Grid container className='inner-container-1' alignItems='' direction={'column'}>
          <div className='display-flex about-logo-badge'>
            <img src={LogoIcon} alt={''} width={80}/>
            <img src={LogoText} alt={''} width={200}/>
          </div>
          <Grid item className='text-container'>
            <p className='eyebrow'>About AgriLive</p>
            <h1>Our purpose</h1>
            <p className='font-16'>AgriLive exists to close the distance between a farmer's field and a fair price.</p>
            <p className='font-16'>Across rural Pakistan, smallholder farmers grow the food that feeds the nation —
              yet remain among its poorest people. Not because they farm badly, but because they cannot reach a
              fair, verified market. Their harvest floods the local market, prices collapse, and much of it rots
              before a fair buyer is ever found.</p>
            <p className='font-16'>AgriLive changes that. We connect smallholder farmers directly to fair markets
              through a verified digital marketplace — proving every step from seed to table, so quality earns the
              price it deserves and farmers keep more of the value they create.</p>
            {/*<Grid item className='mt-60'>*/}
            {/*  <Grid container spacing={2} lg={12}>*/}
            {/*    <Grid item lg={4}>*/}
            {/*      <Button*/}
            {/*        type="submit"*/}
            {/*        fullWidth*/}
            {/*        variant="contained"*/}
            {/*        color="primary"*/}
            {/*        // className={classes.submit}*/}
            {/*        // onClick={onLogin}*/}
            {/*      >*/}
            {/*        Sign In*/}
            {/*      </Button>*/}
            {/*    </Grid>*/}
            {/*    <Grid className='' item lg={4}>*/}
            {/*      <Button*/}
            {/*        type="submit"*/}
            {/*        fullWidth*/}
            {/*        variant="contained"*/}
            {/*        color="primary"*/}
            {/*        // className={classes.submit}*/}
            {/*        // onClick={onLogin}*/}
            {/*      >*/}
            {/*        Sign Up*/}
            {/*      </Button>*/}
            {/*    </Grid>*/}
            {/*  </Grid>*/}
            {/*</Grid>*/}
          </Grid>
        </Grid>
        <Grid container className='inner-container-2' alignItems='flex-end'>
          {features.map((obj, index) => {
            const Icon = ICON_MAP[obj.icon_key] || LocalAtmIcon;
            return (
              <Grid item lg={4} md={4} sm={6} xs={12} key={obj.id} className={`container-2-1 class-${index + 1} white-color `}>
                <div className='content-card' style={{}}>
                  <Icon className='content-card-icon'/>
                  <div className='pl-20 ml-20'>
                    <h2 className=' '>{obj.title}</h2>
                    <hp>{obj.description}</hp>
                  </div>
                </div>
              </Grid>
            )
          })}
        </Grid>

        <Grid container className='container-3' justify='center' alignItems='center' direction={'column'}>
          <Grid item>
            <h1>Welcome To <span className='heading-color'>A</span>gri Livestock Market Place</h1>
          </Grid>
          <Grid item>
            <img src={i11} alt={'icon'}/>
          </Grid>
          <Grid item>
            <p>Our graders grade the top quality harvests ranginng from fresh farm products, grains to live stock and
              fisheries</p>
          </Grid>
          <Grid container className='container-3-1'>
            <Grid item lg={6} md={6} sm={6} style={{background: 'rgb(194, 196, 177)',}} className='p-20'>
              <h1 className='white-color text-capitalize'>We work hard and make your fields <span
                className='black-color'>green</span></h1>
              <p className='white-color font-16'>Our proactive approach has helped in re-shaping the agriculture
                industry. We are the leaders in AI lead
                agriculture</p>
              <Grid container justify='center'>
                {STAT_TILES.map((tile) => (
                  <Grid container alignItems='center' lg={4} md={5} key={tile.key}
                        className="display-flex justify-content-between p-20 m-10"
                        style={{background: '', paddingLeft: '5%', paddingRight: '5%',}}>
                    <img src={tile.img} alt=" " width={50} height={50} className="img-border p-20"/>
                    <h1>-</h1>
                    <h2 className="counter">{stats[tile.key] != null ? stats[tile.key] : '-'}</h2>
                  </Grid>
                ))}
              </Grid>
            </Grid>
            <Grid container lg={6} md={6} sm={6} className=' container-3-1-1 '>
              <Grid item lg={4} md={4} style={{textAlign: 'right', marginTop: 0}} className='c-1 '>
                <h2>Invest <span style={{color: '#a4dd25'}}>In Your</span></h2>
                <h2 style={{color: '#a4dd25'}}>Future</h2>
              </Grid>
              <Grid item lg={7} md={7} style={{textAlign: 'right', alignSelf: 'center', marginTop: 60}} className='c-1'>
                <h3>Engage With Our Consultant And Agri-Scientists To Grow Gold In Your Fields By Increasing Your
                  Harvest Many Folds.</h3>
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        <Grid container className='about-section' direction={'column'}>
          <p className='eyebrow'>A proven approach, not an experiment</p>
          <h2>A model, not just a project</h2>
          <p>Connecting smallholder farmers to fair, functioning markets is one of the most consistently
            evidenced interventions in rural development — improving household income, food security, and
            resilience to climate shocks. AgriLive is designed to deliver exactly this, at scale, with
            verifiable data at every step: farmers registered at source, produce tracked seed-to-table, and
            every sale matched to a fair, verified market.</p>
        </Grid>

        <Grid container className='about-section about-section-cream' direction={'column'}>
          <p className='eyebrow'>Where we work</p>
          <h2>Piloting in Sindh, built to reach every farmer who needs it</h2>
          <p>AgriLive is live and operating today, piloting in District Dadu alongside BASIC Development
            Foundation's active farmer network — reaching communities where up to 75% of the rural population
            lives in poverty and where nearly 40% of the harvest is lost before it ever reaches a fair sale.
            Delivery on the ground is powered by a consortium: Aitropolis Technologies Ltd builds and operates
            the marketplace, BASIC Development Foundation brings fifteen years of trusted last-mile delivery in
            Sindh, and Talking Sense leads community mobilisation and adoption.</p>
          <Grid container className='about-where-grid'>
            <Grid item className='where-card'>
              <strong>District Dadu</strong>
              <span>Current pilot location, Sindh</span>
            </Grid>
            <Grid item className='where-card'>
              <strong>15 yrs</strong>
              <span>BASIC's trusted delivery footprint in Sindh</span>
            </Grid>
            <Grid item className='where-card'>
              <strong>539,305</strong>
              <span>Beneficiaries reached by BASIC's existing programs</span>
            </Grid>
          </Grid>
        </Grid>

        <Grid container className='about-section' direction={'column'}>
          <p className='eyebrow'>Our vision</p>
          <h2>A model built to travel</h2>
          <p>What starts in District Dadu is designed to scale — the same registration, traceability, and fair
            market-matching model can extend to every district in Sindh, and beyond, to any smallholder
            community cut off from a fair market. Every transaction is measured, not merely intended, so the
            impact on income, food security, women's participation, and climate resilience can be proven as the
            model grows.</p>
          <p className='about-vision-quote'>The barrier isn't how farmers farm. It's that they cannot reach a
            fair, verified market. That is what AgriLive changes — one district at a time.</p>
        </Grid>

        <Grid item lg={12} md={12}>
          <Footer/>
        </Grid>
      </div>
    </>
  );
}

export default withRouter(AboutUsPage);
